import { RobotOutlined } from '@ant-design/icons';
import { Tag, Tooltip } from 'antd';

/**
 * MANDATORY label for every AI-derived field (hard constraint #1: AI is decision-support only).
 * Wrap or place next to any value produced by STT/LLM analysis, evaluation, or scoring.
 */
export default function AiAnalysisBadge({ compact = false }: { compact?: boolean }) {
  return (
    <Tooltip title="نتایج تولیدشده توسط هوش مصنوعی — صرفاً پشتیبانِ تصمیم است و مبنای اقدام خودکار قرار نمی‌گیرد.">
      <Tag icon={<RobotOutlined />} color="purple" style={{ marginInlineStart: 4 }}>
        {compact ? 'AI' : 'تحلیل هوش مصنوعی'}
      </Tag>
    </Tooltip>
  );
}
